var TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["Appear"] = "appear";
    TransitionPhase["AppearActive"] = "appear-active";
    TransitionPhase["AppearDone"] = "appear-done";
    TransitionPhase["Enter"] = "enter";
    TransitionPhase["EnterActive"] = "enter-active";
    TransitionPhase["EnterDone"] = "enter-done";
    TransitionPhase["Exit"] = "exit";
    TransitionPhase["ExitActive"] = "exit-active";
    TransitionPhase["ExitDone"] = "exit-done";
})(TransitionPhase || (TransitionPhase = {}));

export { TransitionPhase };
